import React from 'react';
import {Card, Flex} from "antd";
import style from "./CategoryListCard.module.scss";
import {StyledCard} from "./CategoryListCard.styled";
import {LeftOutlined} from "@ant-design/icons";
import {CategoryListCardProps} from "../../models";
import { FaChevronLeft } from "react-icons/fa6";
import {useNavigate} from "react-router-dom";

const CategoryListCard = ({data,onCategoryClick} :CategoryListCardProps) => {
    const navigate =useNavigate()
    return (
        <StyledCard onClick={() => onCategoryClick(data?.id)}  >
            <Flex justify={"space-between"} align={"center"}>
                <Flex gap={"small"} align={"center"}>
                    <img width={21} src={require(`assets/categoryIcons/${data?.icon}`)}/>
                    <span> {data?.name} </span>
                </Flex>
                <span> <FaChevronLeft className={style.icons}/> </span>

            </Flex>
        </StyledCard>
    )

};

export default CategoryListCard;